import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

interface PaperSectionProps {
  children?: React.ReactNode;
  title?: string;
  action?: React.ReactNode;
}

export const PaperSection: React.FC<PaperSectionProps> = ({ children, title, action }) => {
  return (
    <Paper sx={{ mb: 4, p: 0, elevation: 1 }}>
      <Box className="paper-section-title">
        {title && (
          <Typography variant="h5" sx={{ fontWeight: 400 }}>
            {title}
          </Typography>
        )}
        {action && <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>{action}</Box>}
      </Box>
      <Box sx={{ p: 6, pt: 4 }}>{children}</Box>
    </Paper>
  );
};

export default PaperSection;
